import React, { createContext, useCallback, useContext, useState } from "react";

const AdoptModalContext = createContext({
  isOpen: false,
  open: () => {},
  close: () => {},
});

export const AdoptModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  return (
    <AdoptModalContext.Provider value={{ isOpen, open, close }}>
      {children}
    </AdoptModalContext.Provider>
  );
};

export const useAdoptModal = () => useContext(AdoptModalContext);
